export const MATERIAL_IMAGE = 'MaterialImage';
export const BARE_IMAGE = 'BareImage';



// WEBPACK FOOTER //
// ./src/constants/imageTypes.js